const successHandler = (resolve: any) => {
  return (position: { coords: { latitude: any; longitude: any } }) => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    console.log("获取位置成功：", { longitude, latitude });
    resolve({ longitude, latitude });
  };
};
const errorHandler = (reject: { (reason?: any): void; (): void }) => {
  return (error: { message: string }) => {
    console.log("获取位置失败：" + error.message);
    reject();
  };
};
const options = {
  // 高级选项，例如设置获取位置的精度
  enableHighAccuracy: true,
  // 指定获取位置超时的时间，单位为毫秒
  timeout: 1000 * 10,
  // 最长有效期，在这个时间后，即使位置信息还是有效的，也会重新获取一次，单位为毫秒
  maximumAge: 0, // 最大缓存时间为0毫秒，即不使用缓存位置
};
export const getCurrLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(successHandler(resolve), errorHandler(reject), options);
    } else {
      console.log("浏览器不支持Geolocation API");
    }
  });
};
